import menuPlatform from '@/config/menu-platform'
import React from 'react'

export default {
  menuList: [
    {
      icon: <div className="menuImage"></div>,
      key: 'home', //配置成子应用对应的name
      name: '工作台',
      path: '/home',
      sortNumber: 22,
      sysVisibleFlag: 1,
      type: 'menu',
      level: 1,
    },
    {
      children: [
        {
          children: [
            {
              children: [],
              icon: null,
              key: 'znwh',
              name: '智能外呼',
              path: '/marketCloud/callCenter',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'tglj',
              name: '推广链接',
              path: '/marketCloud/promoteLinkSet',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'urlsmpz',
              name: 'URL说明配置',
              path: '/marketCloud/urlSet',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'tmpd',
              name: '天猫拍定',
              path: '/orderManageTmall',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'dppd',
              name: '点评拍定',
              path: '/orderManageMeiTuan',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'sc',
          name: '市场',
          path: '/pageA',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        {
          icon: <div className="markitImage"></div>,
          key: 'yh',
          name: '用户',
          path: '/pageA',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
          children: [
            {
              children: [],
              icon: null,
              key: 'clueInfo',
              name: '线索列表',
              path: '/informationManagement/clueInfo',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'ghc',
              name: '公海池',
              path: '/publicInformation',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'exception',
              name: '异常列表',
              path: '/informationManagement/exception',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'zbxslb',
              name: '总部线索列表',
              path: '/informationManagement/allDispatchList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'xsdr',
              name: '线索导入',
              path: '/Custom/clueImport',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'plgp',
              name: '批量改派',
              path: '/Custom/batchRedenomination',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'rzkcp',
              name: '软装产品库',
              path: '/Custom/productYueLuSoftSpu',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'qwkegl',
              name: '企微客户管理',
              path: '/enterpriseCustomer',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'td',
              name: '谈单',
              path: '/customerTalkOrder',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
        },
        {
          icon: <div className="markitImage"></div>,
          key: 'products',
          name: '商品',
          path: '/pageA',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
          children: [
            {
              children: [],
              icon: null,
              key: 'spgl',
              name: '商品管理',
              path: '',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'splm',
              name: '商品类目',
              path: '',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
        },
        {
          icon: <div className="markitImage"></div>,
          key: 'activity',
          name: '活动',
          path: '/pageA',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
          children: [
            {
              children: [],
              icon: null,
              key: 'promotion',
              name: '促销',
              path: '/promotionFee',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'marketinggifts',
              name: '营销礼',
              path: '/arriveGift',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'depositgifts',
              name: '定金礼',
              path: '/subscriptionGift',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'khxw',
              name: 'h5客户行为',
              path: '/midYearOrderDetail',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              children: [],
              icon: null,
              key: 'hddd',
              name: 'h5活动订单',
              path: '/midYearOrderList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
        },
        {
          children: [
            {
              icon: null,
              key: 'gdlb',
              name: '工单管理',
              path: '/dispatchingList/pendingList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'wtlb',
              name: '问题管理',
              path: '/dispatchingList/matterList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'bxlb',
              name: '报修管理',
              path: '/dispatchingList/repairList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'sh',
          name: '售后',
          path: '/pageA',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        {
          children: [
            {
              icon: null,
              key: 'skgl',
              name: '收款管理',
              path: '',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'costPlan',
              name: '费用计划列表',
              path: '/CostPlanManage/costPlan',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'costPlanApproval',
              name: '费用计划审批',
              path: '/CostPlanManage/costPlanApproval',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'productionRecord',
              name: '渠道消费记录',
              path: '/CostPlanManage/productionRecord',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'costRecord',
              name: '打款报销明细',
              path: '/CostPlanManage/costRecord',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'costPlanSet',
              name: '费用计划管理',
              path: '/CostPlanManage/costPlanSet',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'finance',
          name: '财务',
          path: '/CostPlanManage',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
      ],
      icon: <div className="menuImage"></div>,
      key: 'marketing', //配置成子应用对应的name
      name: '营销',
      path: '',
      sortNumber: 22,
      sysVisibleFlag: 1,
      type: 'sys',
      level: 1,
    },
    ...menuPlatform,
    {
      children: [
        {
          children: [
            {
              icon: null,
              key: 'xszzgl',
              name: '线索账号管理',
              path: '/getUsersConfig/clueAccountSet',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'qygl',
              name: '区域管理',
              path: '/getUsersConfig/companyRule',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'tfpt',
              name: '投放平台',
              path: '/getUsersConfig/launchPlatform',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'hkpz',
          name: '获客配置',
          path: '/pageA',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        {
          children: [
            {
              icon: null,
              key: 'pdgz',
              name: '派单规则',
              path: '/sendSingleRule',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'ecpd',
              name: '二次派单',
              path: '/notTransRule',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'zzqx',
              name: '军种权限',
              path: '/armyTypeList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'ghgz',
              name: '公海规则',
              path: '/openSeasRules',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'pdgzzh',
              name: '派单规则组合',
              path: '/ruleCombination',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },

            {
              icon: null,
              key: 'pdjl',
              name: '派单记录',
              path: '/dispatchLog',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'ecpdlsb',
              name: '二次派单流水表',
              path: '/notTransLogList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'ygpdpzjl',
              name: '员工派单配置记录',
              path: '/dispatchRuleEmployeeConfigLog',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'ywgwpz',
              name: '业务岗位配置',
              path: '/businessRoleConfig',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            
          ],
          icon: <div className="markitImage"></div>,
          key: 'xspdpz',
          name: '线索派单配置',
          path: '/pageA',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        {
          icon: <div className="markitImage"></div>,
          key: 'lpqd',
          name: '楼盘配置',
          path: '/pageA',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          children: [
            {
              icon: null,
              key: 'lplb',
              name: '楼盘管理',
              path: '/buildingList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'lpqy',
              name: '楼盘区域',
              path: '/buildingArea',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'kfsgl',
              name: '开发商管理',
              path: '/estateManage/developerlist',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'tcpfypz',
              name: '同城配费用',
              path: '/estateManage/cityTransConfig',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          level: 2,
        },

        {
          children: [
            {
              icon: null,
              key: 'qdk',
              name: '渠道库',
              path: '/channelManagement/channelLibrary',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'qdflgl',
              name: '渠道分类管理',
              path: '/channelManagement/channelClass',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'qdpz',
          name: '渠道配置',
          path: '',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        // {
        //   children: [
        //     {
        //       icon: null,
        //       key: 'cjgl',
        //       name: '场景关联',
        //       path: '/sceneSetList',
        //       sortNumber: 0,
        //       sysVisibleFlag: 1,
        //       type: 'menu',
        //     },
        //     {
        //       icon: null,
        //       key: 'cjpz',
        //       name: '场景配置',
        //       path: '/sceneSetList',
        //       sortNumber: 0,
        //       sysVisibleFlag: 1,
        //       type: 'menu',
        //     },
        //   ],
        //   icon: <div className="markitImage"></div>,
        //   key: 'cjgl',
        //   name: '场景管理',
        //   path: '',
        //   sortNumber: 0,
        //   sysVisibleFlag: 1,
        //   type: 'menu',
        //   level: 2,
        // },
        {
          children: [
            {
              key: 'template',
              name: '模板列表',
              path: '/notify/template',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },

            {
              icon: null,
              key: 'zhgl',
              name: '账号管理',
              path: '/notify/account',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'tzrz',
              name: '通知日志',
              path: '/notify/logs',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'sxxx',
              name: '上行消息',
              path: '/notify/upMessage',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'sxxxdy',
              name: '上行消息订阅',
              path: '/notify/upMessageSubscribeConfig',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              key: 'platform',
              name: '平台管理',
              path: '/notify/platform',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'tztj',
              name: '通知统计',
              path: '/notify/trendStatistics',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'xxgl',
          name: '消息管理',
          path: '',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },

        {
          children: [
            {
              icon: null,
              key: 'yygl',
              name: '应用管理',
              path: '/weixin/app',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'wxyhlb',
              name: '微信用户列表',
              path: '/weixin/user',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'dljl',
              name: '登录记录',
              path: '/weixin/userLoginLog',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'wxyzwj',
              name: '微信验证文件',
              path: '/weixin/validationFile',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'wxglpz',
          name: '微信管理配置',
          path: '',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        {
          children: [
            {
              icon: null,
              key: 'bbgl',
              name: '目标管理',
              path: '/systemConfig/objectiveManage',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'yjqgl',
              name: '业绩期管理',
              path: '/systemConfig/achievementDate',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'mbpz',
          name: '目标配置',
          path: '',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        {
          children: [
            {
              icon: null,
              key: 'yqlj',
              name: '友情链接',
              path: '/websiteConfig/friendlyLink',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'cdlb',
              name: '菜单列表',
              path: '/websiteConfig/menuList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'jcxx',
              name: '基础信息',
              path: '/websiteConfig/siteConfig',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'dbdh',
              name: '底部导航',
              path: '/websiteConfig/linkGroup',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'dyylj',
              name: '多语言链接',
              path: '/websiteConfig/siteLinkList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'ggwlb',
              name: '广告位列表',
              path: '/websiteConfig/advertisementList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'kjlb',
              name: '空间列表',
              path: '/websiteConfig/seriesList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'pllb',
              name: '品类列表',
              path: '/websiteConfig/categoryList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'cplb',
              name: '产品列表',
              path: '/websiteConfig/productList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'algl',
              name: '案例管理',
              path: '/websiteConfig/caseList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'gwxxpz',
          name: '官网信息配置',
          path: '',
          sortNumber: 1,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        {
          children: [
            {
              icon: null,
              key: 'kjlzh',
              name: '酷家乐账号',
              path: '/marketCloud/kuklerAccount',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'gdpz',
              name: '工单配置',
              path: '/dispatchingList/manageConfig',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'kjlxgl',
              name: '空间类型管理',
              path: '/spaceTypeManagement',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'shcjgl',
              name: '生活场景管理',
              path: '/lifeSceneManagement',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'cgewm',
              name: '场馆二维码',
              path: '/venueQRCodeList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'qtpz',
          name: '其他配置',
          path: '',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        {
          children: [
            {
              icon: null,
              key: 'bqgl',
              name: '标签管理',
              path: '/productContentConfig/tagManage',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'kjfapz',
              name: '空间方案配置',
              path: '/productContentConfig/caseManage',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'tandpz',
          name: '谈单配置',
          path: '',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
      ],
      icon: <div className="menuImage"></div>,
      key: 'marketing', //配置成子应用对应的name
      name: '配置中心',
      path: '/pageA',
      sortNumber: 0,
      sysVisibleFlag: 1,
      type: 'sys',
      level: 1,
    },
    {
      children: [
        {
          icon: <div className="markitImage"></div>,
          key: 'applicationSourceConfig',
          name: '系统资源配置',
          path: '',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
          children: [
            {
              icon: null,
              key: 'subTransferLogs',
              name: '子变分',
              path: '/upms/subTransfer/logList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'subTransfer',
              name: '子变分关系配置',
              path: '/upms/subTransfer',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'dictConfig',
              name: '数据字典',
              path: '/upms/dict',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },

            {
              icon: null,
              key: 'applicationConfig',
              name: '系统配置',
              path: '/upms/application',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'paramsConfig',
              name: '参数配置',
              path: '/upms/paramConfig',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'cwdmgl',
              name: '错误代码管理',
              path: '/upms/errorCode',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'xxtzpz',
              name: '消息通知配置',
              path: '/upms/noticeConfig',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'bmgzpz',
              name: '编码规则配置',
              path: '/upms/codeRule',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'rjbbgl',
              name: '软件版本管理',
              path: '/upms/softwareVersion',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'sjhmpb',
              name: '手机号码屏蔽配置',
              path: '/upms/telPhoneConfig',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'sjhmpb22',
              name: 'test',
              path: '/upms/test',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
        },
        {
          children: [
            {
              icon: null,
              key: 'zzgl',
              name: '组织管理',
              path: '/org/index',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'zwgl',
              name: '职位管理',
              path: '/deptPos/index',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'yggl',
              name: '员工管理',
              path: '/employee/index',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'gwgl',
              name: '岗位管理',
              path: '/position/index',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            // {
            //   icon: null,
            //   key: 'qyrz',
            //   name: '企业认证',
            //   path: '/esignCopmpanyCfig/index',
            //   sortNumber: 0,
            //   sysVisibleFlag: 1,
            //   type: 'menu',
            // },
            // {
            //   icon: null,
            //   key: 'wbzhgl',
            //   name: '外部账号管理',
            //   path: '/externalAuthentication/index',
            //   sortNumber: 0,
            //   sysVisibleFlag: 1,
            //   type: 'menu',
            // },
          ],
          icon: <div className="markitImage"></div>,
          key: 'zzjg',
          name: '组织架构',
          path: '',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        {
          children: [
            // {
            //   icon: null,
            //   key: 'qxsx',
            //   name: '权限失效',
            //   path: '/role/authExpManagement',
            //   sortNumber: 0,
            //   sysVisibleFlag: 1,
            //   type: 'menu',
            // },
            {
              icon: null,
              key: 'jsgl',
              name: '角色管理',
              path: '/role/rolesManagement',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            // {
            //   icon: null,
            //   key: 'ctjspz',
            //   name: '冲突角色设置',
            //   path: '/role/conflictRoleManagement',
            //   sortNumber: 0,
            //   sysVisibleFlag: 1,
            //   type: 'menu',
            // },
            // {
            //   icon: null,
            //   key: 'kfptkhdpz',
            //   name: '开放平台客户端配置',
            //   path: '/clientMobileManager',
            //   sortNumber: 0,
            //   sysVisibleFlag: 1,
            //   type: 'menu',
            // },
            {
              icon: null,
              key: 'fgswwpz',
              name: '分公司外网配置',
              path: '/companyIpManage/index',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'ipdzjygl',
              name: 'IP地址校验管理',
              path: '/ipVerify',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'qxgl',
          name: '权限管理',
          path: '',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        {
          children: [
            {
              icon: null,
              key: 'dlrz',
              name: '登录日志',
              path: '/logManage/loginLogList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'czrz',
              name: '操作日志',
              path: '/logManage/operationLogList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
            {
              icon: null,
              key: 'ebstbrz',
              name: 'EBS同步日志',
              path: '/logManage/ebsSyncLogList',
              sortNumber: 0,
              sysVisibleFlag: 1,
              type: 'menu',
            },
          ],
          icon: <div className="markitImage"></div>,
          key: 'rzgl',
          name: '日志管理',
          path: '',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
      ],
      icon: <div className="menuImage"></div>,
      key: 'marketing', //配置成子应用对应的name
      name: '组织与权限',
      path: '',
      sortNumber: 22,
      sysVisibleFlag: 1,
      type: 'sys',
      level: 1,
    },
    {
      icon: <div className="menuImage"></div>,
      key: 'pms', //配置成子应用对应的name
      name: '交付',
      path: '/pms',
      sortNumber: 22,
      sysVisibleFlag: 1,
      type: 'sys',
      children: [
        {
          key: 'cockpitTable',
          name: '驾驶舱报表',
          path: '/cockpitTable/list',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
        {
          key: 'systemConfig',
          name: '工种管理',
          path: '/systemConfig/workType',
          sortNumber: 0,
          sysVisibleFlag: 1,
          type: 'menu',
          level: 2,
        },
      ],
      level: 1,
    },
  ],
}
